@if (!!currentBreadcrumb) {
  <p>
    <strong>{{ currentBreadcrumb.vehicle.label }} @if (currentBreadcrumb.driver !== null) {<span>: {{currentBreadcrumb.driver.givenName}} {{currentBreadcrumb.driver.familyName}}</span>}</strong>
  </p>

  @if (hasDashCamFeatureFlag) {
    <div>
      @if (loadingImage) {
        <mat-spinner [diameter]="18"></mat-spinner>
      }
      <img
        class="preview_image"
        [src]="imageData"
        [alt]="'dashcam preview'"
        (error)="onImageError()"
        (load)="onImageLoad()"
        [hidden]="imageError || noCamera"
      />
      <!--<span *ngIf="!loadingImage && imageError">No video</span>-->
    </div>
  }

  <table>
    <tr>
      <th>Location:</th>
      <td>{{ [currentBreadcrumb.location.longitude, currentBreadcrumb.location.latitude] | latLng }}</td>
    </tr>
    <tr>
      <th>Time:</th>
      <td>{{currentBreadcrumb.time | date:'shortDate'}} {{currentBreadcrumb.time | date:'mediumTime'}}</td>
    </tr>
    @if (currentBreadcrumb.location.speed) {
      <tr>
        <th>Speed:</th>
        <td>
          @if (!!configuration) {
            <span>{{currentBreadcrumb.location.speed | speed:configuration.useMetricSystem}}</span>
          }
        </td>
      </tr>
    }
    @if (currentBreadcrumb.location.heading) {
      <tr>
        <th>Heading:</th>
        <td>{{currentBreadcrumb.location.heading | compass}}</td>
      </tr>
    }
    @if (currentBreadcrumb.location.gpsSource) {
      <tr>
        <th>GPS Source:</th>
        <td>{{ +currentBreadcrumb.location.gpsSource | gpsSource }}</td>
      </tr>
    }
    @if (currentBreadcrumb.vehicle.hardwareConfiguration &&
      currentBreadcrumb.vehicle.hardwareConfiguration.sensorInputs &&
      currentBreadcrumb.vehicle.hardwareConfiguration.sensorInputs.length > 0
    ) {
      @for (sensorInput of HardwareConfiguration.getValidInputs(currentBreadcrumb.vehicle.hardwareConfiguration.sensorInputs); track $index) {
        <tr>
          @if (sensorInput.type === SensorType.PLOW || sensorInput.type === SensorType.PLOW2W) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Plow' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | plowStatus: currentBreadcrumb.location.flags }}
            </td>
          } @else if (sensorInput.type === SensorType.GRANULAR_SPREADER) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Granular Spreader' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | spreaderStatus: currentBreadcrumb.location.flags }}
              ({{ sensorInput.rate || 'N/A' }} {{'granular' | rateUnit:configuration.useMetricSystem}})
            </td>
          } @else if (sensorInput.type === SensorType.DIGITAL_GRANULAR_SPREADER && !!digitalGranularStatus) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Digital Granular Spreader' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | spreaderStatus: currentBreadcrumb.location.flags }}
              ({{(digitalGranularStatus.controllerCurrentRate | spreaderMass:configuration.useMetricSystem) || 'N/A' }})
            </td>
          } @else if (sensorInput.type === SensorType.LIQUID_SPREADER) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Liquid Spreader' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | spreaderStatus: currentBreadcrumb.location.flags }}
              ({{ sensorInput.rate || 'N/A' }} {{'liquid' | rateUnit:configuration.useMetricSystem }})
            </td>
          } @else if (sensorInput.type === SensorType.DIGITAL_LIQUID_SPREADER && !!digitalLiquidStatus) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Digital Liquid Spreader' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | spreaderStatus: currentBreadcrumb.location.flags }}
              ({{(digitalLiquidStatus.controllerCurrentRate | spreaderLiquid:configuration.useMetricSystem) || 'N/A' }})
            </td>
          } @else if (sensorInput.type === SensorType.MOWER) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Mower' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | mowerStatus: currentBreadcrumb.location.flags }}
            </td>
          } @else if (sensorInput.type === SensorType.SWEEPER) {
            <th>
              {{ !!sensorInput.label ? sensorInput.label : 'Sweeper' }}
            </th>
            <td>
              {{ sensorInput.bitNumber | sweeperStatus: currentBreadcrumb.location.flags }}
            </td>
          }
        </tr>
      }
    }
  </table>

  @if (isLiveMap && !isShiftActive(currentBreadcrumb.shiftId)) {
    <div>
      <a [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.SHIFT_REPORT, InsightsRoute.SHIFT_DETAIL, currentBreadcrumb.shiftId]"
         class="view-link">Open Shift Detail</a>
    </div>
  }

  @if (currentBreadcrumb.imageUrl) {
    <div class="dash-cam-image-thumbnail">
      <app-retrying-image-viewer [imageUrl]="currentBreadcrumb.imageUrl"
                                 [alternativeText]="'Dashboard Camera Image'"></app-retrying-image-viewer>
    </div>
  }

  @if (breadcrumbs.length > 1) {
    <mat-paginator
                   [length]="breadcrumbs.length"
                   [pageSize]="1"
                   [hidePageSize]="true"
                   [showFirstLastButtons]="true"
                   (page)="handlePageEvent($event)">
    </mat-paginator>
  }
}
